import { Select, Spin } from 'antd'
import { useEffect, useState, useRef } from 'react'
import { getGamesByCategory } from 'src/api/game'

const PAGE_SIZE = 10

const GameSelect = ({
  value,
  style,
  onChange,
  placeholder = 'Select Game',
}) => {
  const [games, setGames] = useState([])
  const [loading, setLoading] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')
  const [hasMore, setHasMore] = useState(true)
  const currentPageRef = useRef(0)

  const loadGames = async ({ reset = false, search = '' } = {}) => {
    try {
      setLoading(true)
      const page = reset ? 0 : currentPageRef.current
      const response = await getGamesByCategory(page, PAGE_SIZE, search)
      const newGames = response.data.map((item) => ({
        label: item.title,
        value: item.id,
      }))

      setGames((prev) => (reset ? newGames : [...prev, ...newGames]))
      currentPageRef.current = page + 1
      setHasMore(newGames.length === PAGE_SIZE)
    } catch (error) {
      console.error('Failed to load games:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    loadGames({ reset: true })
  }, [])

  const handlePopupScroll = (e) => {
    const target = e.target
    if (
      !loading &&
      hasMore &&
      target.scrollTop + target.offsetHeight >= target.scrollHeight - 50
    ) {
      loadGames({ search: searchTerm })
    }
  }

  const handleSearch = (value) => {
    setSearchTerm(value)
    currentPageRef.current = 0
    loadGames({ reset: true, search: value })
  }

  const handleClear = () => {
    setSearchTerm('')
    currentPageRef.current = 0
    loadGames({ reset: true })
    onChange(undefined)
  }

  return (
    <Select
      showSearch
      value={value}
      placeholder={placeholder}
      onChange={onChange}
      onSearch={handleSearch}
      filterOption={false}
      options={games}
      style={style}
      onPopupScroll={handlePopupScroll}
      allowClear
      onClear={handleClear}
      loading={loading}
      notFoundContent={loading ? <Spin size="small" /> : null}
    />
  )
}

export default GameSelect
